import { mapEnum } from 'utils/global';
import { LegalForm } from '__generated__/api';

export const filteredLegalForms = mapEnum(LegalForm).filter(
  (x: string) => x !== LegalForm.OneManBusiness
);
